import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import intlShape from '../lib/intlShape.js';
import {costumeShape} from '../lib/assets-prop-types.js';
import VM from '@scratch/scratch-vm';
import mergeDynamicAssets from '../lib/merge-dynamic-assets.js';

import costumeLibraryContent from '../lib/libraries/costumes.json';
import spriteTags from '../lib/libraries/sprite-tags';
import LibraryComponent from '../components/library/library.jsx';
import {GUIStoragePropType} from '../gui-config';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Costume',
        description: 'Heading for the costume library',
        id: 'gui.costumeLibrary.chooseACostume'
    }
});


class CostumeLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelected',
            'mergeDynamicAssets'
        ]);
        this.processedCostumes = {};
    }
    handleItemSelected (item) {
        const vmCostume = {
            name: item.name,
            rotationCenterX: item.rotationCenterX,
            rotationCenterY: item.rotationCenterY,
            bitmapResolution: item.bitmapResolution,
            skinId: null
        };
        this.props.vm.addCostumeFromLibrary(item.md5ext, vmCostume);
    }
    mergeDynamicAssets () {
        if (this.processedCostumes.source === this.props.dynamicCostumes &&
            this.processedCostumes.showBuiltin === this.props.showBuiltinCostumes) {
            return this.processedCostumes.data;
        }
        const staticAssets = this.props.showBuiltinCostumes === false ? [] : costumeLibraryContent;
        this.processedCostumes = mergeDynamicAssets(
            staticAssets,
            this.props.dynamicCostumes
        );
        this.processedCostumes.showBuiltin = this.props.showBuiltinCostumes;
        return this.processedCostumes.data;
    }
    render () {
        const data = this.mergeDynamicAssets();
        const {costumeTags, showBuiltinCostumes} = this.props;
        let tags = spriteTags;
        if (showBuiltinCostumes === false) {
            tags = costumeTags || [];
        } else if (costumeTags) {
            tags = spriteTags.concat(costumeTags);
        }
        return (
            <LibraryComponent
                data={data}
                id="costumeLibrary"
                storage={this.props.storage}
                tags={tags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelected}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
};

const mapStateToProps = state => {
    const projectFile = state.scratchGui.projectFile.projectFile;
    const da = state.scratchGui.dynamicAssets;
    let showBuiltinCostumes;
    if (da.showBuiltinCostumes !== null) {
        showBuiltinCostumes = da.showBuiltinCostumes;
    } else if (projectFile && projectFile.ui) {
        showBuiltinCostumes = projectFile.ui.showBuiltinCostumes;
    }
    return {
        storage: state.scratchGui.config.storage,
        dynamicCostumes: da.costumes,
        costumeTags: da.costumeTags,
        showBuiltinCostumes
    };
};

CostumeLibrary.propTypes = {
    costumeTags: PropTypes.arrayOf(PropTypes.shape({
        tag: PropTypes.string,
        intlLabel: PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string
        })
    })),
    dynamicCostumes: PropTypes.arrayOf(costumeShape),
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    storage: GUIStoragePropType,
    showBuiltinCostumes: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(connect(mapStateToProps)(CostumeLibrary));
